// A visitor who clicks "Start with Pro" on the landing page has to register and confirm their
// email before anything can be charged, and the confirmation link arrives out of band. A query
// string cannot survive that round trip, so the intent is parked here until the session exists.

const STORAGE_KEY = "taskit.pending_plan";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const PLAN_PRO = "pro";

export const setPendingPlan = (plan = PLAN_PRO) => {
  try {
    window.localStorage?.setItem(STORAGE_KEY, JSON.stringify({ plan, savedAt: Date.now() }));
  } catch {
    // Private browsing and blocked storage are fine: the user simply lands in the app and can
    // upgrade from Settings instead.
  }
};

export const readPendingPlan = () => {
  try {
    const raw = window.localStorage?.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { plan, savedAt } = JSON.parse(raw);
    // An intent left over from days ago must not hijack an unrelated login.
    if (!plan || !savedAt || Date.now() - savedAt > MAX_AGE_MS) {
      clearPendingPlan();
      return null;
    }
    return plan;
  } catch {
    clearPendingPlan();
    return null;
  }
};

export const clearPendingPlan = () => {
  try {
    window.localStorage?.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clean up if storage is unavailable.
  }
};
